export default "__VITE_ASSET__Ct12E$LH__"